import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import clsx from 'clsx';
import { Grid, ThemeProvider } from '@material-ui/core';
import apiService from '../../services/apiService';
import '../../styling/Styles.css';
import WabliBreadcrumb from '../WabliBreadcrumb';
import { muiTheme } from '../../styling/Styles';
import AuthContext from '../AppAuthContext';
import WabliAppBar from '../WabliAppbar/WabliAppBar';
import GithubProfInfo from './GithubProfInfo';
import ProjectsTable from './ProjectsTable/ProjectsTable';
import KickedOutMessage from './ErrorPage.js/KickedOutMessage';

export const Home = () => {
  const { state, dispatch } = useContext(AuthContext);
  const [data, setData] = React.useState([]);
  const [updateData, setUpdateData] = React.useState(false);
  const [init, setInit] = React.useState(false);
  const [displayKickedOutMessage, setDisplayKickedOutMessage] = React.useState(false);

  useEffect(() => {
    if (init === false) {
      setInit(true);
    }
  }, [init]);

  // Load the user's Projects
  useEffect(() => {
    if (state.isLoggedIn && init === true) {
      apiService
        .getUsersProjects(state.user._id)
        .then((response) => {
          setData(response.data);
          localStorage.setItem('data', JSON.stringify(response.data));
        })
        .catch((err) => {
          if (err.message === 'authentication failed') {
            dispatch({ type: 'LOGOUT' });
          }
          throw err;
        });
    }
    setUpdateData(false);
  }, [dispatch, state, updateData, init]);

  useEffect(() => {
    const interval = setInterval(() => {
      apiService
        .getUsersProjects(state.user._id)
        .then((response) => {
          setData(response.data);
          localStorage.setItem('data', JSON.stringify(response.data));
        })
        .catch((err) => {
          if (err.message === 'authentication failed') {
            dispatch({ type: 'LOGOUT' });
          }
          throw(err);
        });
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  if (!state.isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <div style={{ height: '100%', overflow: 'auto' }}>
        <WabliAppBar setUpdateData={setUpdateData} updateData={updateData} />
        <WabliBreadcrumb name="" />
        <ThemeProvider theme={muiTheme}>
          <div className={clsx('generalMarg', 'spacingTop')}>
            <Grid container direction="column">
              <div style={{ display: 'flex' }}>
                <GithubProfInfo />
                <div
                  style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '2rem' }}
                  className={clsx('lightBlue', 'titleFont')}
                >
                  {' '}
                  My projects{' '}
                </div>
              </div>

              <ProjectsTable
                data={data}
                setUpdateData={setUpdateData}
                updateData={updateData}
                setDisplayKickedOutMessage={setDisplayKickedOutMessage}
                isHome
              />
              <div style={{ marginTop: '1rem' }} />
            </Grid>
          </div>
        </ThemeProvider>
      </div>
      <KickedOutMessage
        displayKickedOutMessage={displayKickedOutMessage}
        setDisplayKickedOutMessage={setDisplayKickedOutMessage}
      />
    </>
  );
};

export default Home;
